import { render, staticRenderFns } from "./ClientProjectsEditDetailsStep2.vue?vue&type=template&id=247ec451&"
import script from "./ClientProjectsEditDetailsStep2.vue?vue&type=script&lang=js&"
export * from "./ClientProjectsEditDetailsStep2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports